
import angular from 'angular';
import TestimoniesComponent from './testimonies.component';

let TestimoniesModule = angular.module('home.testimonies',[])
.component('testimonies',TestimoniesComponent);
export default TestimoniesModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/shared/components/testimonies/testimonies.js
 **/